import React from 'react';

import { useLayout } from '../../state/layout';

import css from './Layout.module.scss';

const layoutTypeClassMap = {
  default: css.layout,
  compressed: css.compressed
};

interface LayoutProps {
  'data-e2e'?: string;
  children?: React.ReactNode;
}

const Layout = (props: LayoutProps) => {
  const layout = useLayout();
  return (
    <div
      data-e2e={props['data-e2e'] ? props['data-e2e'] : 'layout'}
      className={layoutTypeClassMap[layout || 'default']}
    >
      {props.children}
    </div>
  );
};

export default Layout;
